<template>
    

    <main class="hp-bg-color-dark-90 d-flex min-vh-100"  >

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout" style="overflow-x: hidden;" >

            <!-- HEADER -->
            <HeaderBody />

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content"  >

                <div class="row mb-32 gy-0 dash-top" >

                    
                    <div  >
                        <h2 class="dd-none" style="margin-top: -40px;"></h2>
                        <h2 class="mm-none" style="margin-top: 20px;"></h2>
                        <div class="card-group">

                            <div class="col-12 " >
                                <div class="row " >
                                    
                                    <!-- USER LIST -->
                                    <div class="card col-12 col-md-4" style="   height: 100vh; border-top-right-radius: 0px; border-bottom-right-radius: 0px; position: relative; padding: 0; margin: 0; max-width: 100%; border-radius: 0px;" ref="userListBox" id="userListBox">
                                        
                                        <div class="card-header" style="padding-top: 20px; background-color: transparent;  z-index: 8; ">
                                            <div class="mm-none" style="display: flex; justify-content: space-between; align-items: center;">

                                                <h5 class="card-title mm-none" id="convoTitle">Conversations</h5>

                                            <div class="hp-header-search col d-none" id="userSearch">
                                                <input type="text" class="form-control" placeholder="Search users..." id="header-search" autocomplete="off">
                                            </div>

                                            <!-- <button @click="searchOpen" id="searchButton" type="button" class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-fle align-items-center justify-content-center mm-none" style="height: 30px;" >
                                                
                                                <i class="hp-header-search-button-icon-2 ri-search-2-line hp-text-color-black-100" style="font-size: 18px; "></i>

                                                <i class="hp-header-search-button-icon-2 iconly-Light-AddUser hp-text-color-black-100" style="font-size: 18px;"></i>
                                                
                                            </button> -->

                                            <div  class="d-flex align-items-center justify-content-end mm-none">

                                                <button type="button" id="addButton" class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-fle align-items-center justify-content-center mm-none" style="height: 30px;" data-bs-toggle="modal" data-bs-target="#contacts">
                                                
                                                    <i class="hp-header-search-button-icon-2 ri-mail-add-line hp-text-color-black-100" style="font-size: 18px; "></i>

                                                </button>

                                                <button @click="searchOpen" id="searchButton" type="button" class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-fle align-items-center justify-content-center mm-none" style="height: 30px;" >
                                                
                                                    <i class="hp-header-search-button-icon-2 ri-search-2-line hp-text-color-black-100" style="font-size: 18px; "></i>

                                                </button>

                                                
                                            </div>

                                            

                                            <button @click="searchClose" id="searchButtonC" type="button" class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-flex align-items-center justify-content-center d-none" style="height: 30px;" >
                                                
                                                <i class="hp-header-search-button-icon-2 ri-close-line hp-text-color-black-100 " style="font-size: 18px;"></i>
                                            </button>

                                            

                                            </div>

                                            <div class="dd-none" style="width: 100%;" id="addBtnMobile">
                                                <div class="hp-header-search col" id="userSearch">
                                                    <input type="text" class="form-control" placeholder="Search users..." id="header-search" autocomplete="off">
                                                </div>

                                                <button class="btn btn-icon-only rounded-circle btn-primary" style="position: absolute; bottom: 150px; right: 10px; " data-bs-toggle="modal" data-bs-target="#contacts">
                                                    <i class=" ri-mail-add-line remix-icon" ></i>
                                                </button>

                                                
                                            </div>

                                            
                                            
                                        </div>



                                        <div class="card-body" style="padding: 0; overflow-y: scroll; overflow-x: hidden; cursor: pointer; margin: 0;">
                                            
                                            <div v-for="(convo, index) in convoList" :key="'number'+index" :id="convo.userId" class="col-12 userCol" style="position: relative; " @click="startChat(convo, index)">

                                                <span v-if="convo.lastMsg != ''" class="hp-badge-text" style="font-size: 10px; position: absolute; right: 20px;top: 20px;"> {{ convo.lastTimestampD }} </span>

                                                <span v-if="convo.unreadCount > 0" class="badge rounded-circle bg-primary-1 hp-bg-dark-primary-1 text-white ms-8 position-absolute" style="border-color: #9146ff; background-color: #9146ff !important; padding: 5px; right: 20px; top: 40px; font-size: 10px; border-radius: 50%; width: 25px; height: 25px; text-align: center; justify-content: center; align-items: center; display: flex;" > {{ convo.unreadCount }} </span>

                                                <span v-if="convo.unreadCount > 99" class="badge rounded-circle bg-primary-1 hp-bg-dark-primary-1 text-white ms-8 position-absolute" style="border-color: #9146ff; background-color: #9146ff !important; padding: 5px; right: 20px; top: 40px; font-size: 10px; border-radius: 50%; width: 25px; height: 25px; text-align: center; justify-content: center; align-items: center; display: flex;" > 99+ </span>

                                                <div class="row align-items-center " style="padding-left: 30px; padding-right: 0px; padding-top: 15px; padding-bottom: 15px;">

                                                    <div class="w-auto px-0"  style="cursor: pointer;">
                                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                                            <img :src="convo.profilePic"  class="hp-img-cover" style="width: 48px; height: 48px; background-color: black; object-fit: cover; border-color: black; border-width: 1px; border-style: solid; ">
                                                        </div>
                                                    </div>

                                                    <div class="w-auto ms-8 px-0 mt-12" >
                                                        <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS" style="width: 180px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ convo.fullname }}
                                                            <span v-if="convo.lastMsg != '' || convo.lastMsgType!='' " class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4" >@{{ convo.username }}</span>
                                                            
                                                            <!-- <span>
                                                                    <img src="@/assets/img/check-circle.png" alt="" width="15px"> 
                                                                </span>  -->

                                                        </span>
                                                        <p v-if="convo.lastMsg != '' || convo.lastMsgType != ''" class="hp-p1-body fw-normal hp-text-color-dark-30 mt-4" style="width: 230px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "> 
                                                            
                                                            <span v-if="convo.lastMsgType.startsWith('image') " style="position: relative;"> 
                                                                <i class="hp-text-color-dark-0 iconly-Light-Image" style="font-size: 18px; position: absolute; top: 0px;"></i>  
                                                                <span style="margin-left: 20px;"> ... {{ convo.lastMsg }} </span>
                                                            </span>

                                                            <span v-else-if="convo.lastMsgType.startsWith('video')" style="position: relative"> 
                                                                <i class="hp-text-color-dark-0 iconly-Light-Video" style="font-size: 18px; position: absolute; top: 0px;"></i>  
                                                                <span style="margin-left: 20px;"> ... {{ convo.lastMsg }} </span>
                                                                
                                                            </span>

                                                            <span v-else-if="convo.lastMsgType.startsWith('tip')"> 
                                                                <span style="font-size: 13px;" >&#8358; {{ convo.tipAmount }} Tip</span>
                                                                <span style="margin-left: 0px;"> ... {{ convo.lastMsg }} </span>
                                                            </span>

                                                            <span v-else-if="convo.lastMsgType.startsWith('text')"> 
                                                                
                                                                <span> {{ convo.lastMsg }} </span>
                                                            </span>

                                                            

                                                        </p>

                                                        <span v-else class="hp-p1-body fw-normal hp-text-color-dark-30 mt-4" style="width: 230px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "> 
                                                            
                                                            

                                                            @{{ convo.username }}

                                                        </span>



                                                        
                                                    </div>

                                                    
                                                </div>

                                                <div class="divider mt-0 mb-0" style="margin: 0; padding:0"></div>

                                            </div>

                                            
                                        </div>
                                    </div>

                                    <!-- MESSGAES -->
                                    <div v-if="currentPeerUser == null" class="card col-12 col-md-8 ovx1"  ref="chatBox" id="chatBox">

                                        <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column;">

                                            <h4>No conversation selected</h4>
                                            <p class="hp-p1-body">Select a conversation or send a new message...</p>
                                            <button class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#contacts" style="margin-top: 30px;">New message</button>
                                        </div>
                                        
                                    </div>

                                    <div ref="chatBox" v-else class="card col-12 col-md-8 ovx1" id="chatBox">

                                        <MessageRBody  v-bind:currentPeerUser="currentPeerUser"/>
                                        
                                    </div>

                                </div>
                            </div>

                            

                        </div>

                        
                    </div>

                    

                    
                </div>

                 <!-- FOOTER -->
                

            </div>

        </div>

    </main>


    <!-- SCROLL TO TOP -->
    

    

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SEND TIP -->
        <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h5 style="text-align: center; width: 100%" class="modal-title">Send tip to @{{ userName }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -40px;">

                        <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                        <form @submit.prevent="sendTip">

                            <div class="mb-24" style="margin-top: 30px;">

                                <label for="displayName" class="form-label">Amount</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                    <input type="number" class="form-control" placeholder="100 to 50,000" aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                                </div>

                            </div>

                            <div class="mb-24">

                                <label for="displayName" class="form-label">Message</label>
                                <textarea name="description" id="description" class="form-control" rows="4"  placeholder="Type a message here (optional)..."  style="line-height: 20px; padding-top: 10px;" v-model="message" maxlength="500"></textarea>

                            </div>

                            <div class="divider mt-18 mb-16"></div>

                            

                            <div class="modal-footer d-flex justify-content-center">
                                
                                <button class="btn btn-primary">Confirm</button>
                            </div>

                        </form>

                        

                        

                        
                        
                    </div>

                    
                </div>
            </div>
        </div>

        <!-- SEND IMAGE -->
        <div class="modal fade" id="sendImage" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Send media to @{{ userName }}</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -40px;">

                        <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                        <form @submit.prevent="sendTip">

                            <div class="mb-24" style="margin-top: 30px; " >

                                <img src="@/assets/img/imggs.png" alt="." style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;" >

                            </div>

                            

                            <div class="mb-24" >

                                <input type="file" class="form-control" accept="video/*,image/*" id="previewSelect">

                            </div>

                            <div class="mb-24">

                                <label for="displayName" class="form-label">Price</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                    <input type="number" class="form-control" placeholder="0.00 (Free)" aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                                </div>

                            </div>

                            <div class="divider mt-18 mb-16"></div>

                            

                            <div class="modal-footer d-flex justify-content-center">
                                
                                <button class="btn btn-primary">Confirm</button>
                            </div>

                        </form>

                        

                        

                        
                        
                    </div>

                    
                </div>
            </div>
        </div>

        <!-- CONTACTS -->
        <div class="modal fade" id="contacts" tabindex="-1" aria-labelledby="contactsLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Select user</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                        
                    </div>

                    <div class="col-12" style="padding-left: 10px; padding-right: 10px;">
                        <div class="row">
                            <div class="hp-header-search ">
                                <input type="text" class="form-control" placeholder="Search users..." id="header-search" autocomplete="off" >
                            </div>
                        </div>
                    </div>

                    <div class="modal-body" style="margin-top: 0px; margin-bottom: 100px;">
                        
                        
                        <div class="col-12" v-for="(contact, index) in contactList" :key="'number'+index">
                            <div @click="selectUser(contact)" class="row align-items-center" style="margin-bottom: 20px; cursor: pointer;" data-bs-dismiss="modal">

                                <div class="w-auto px-0"  style="cursor: pointer;">
                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                        <img :src="contact.profilePic"  class="hp-img-cover" style="width: 48px; height: 48px; background-color: black; object-fit: cover; border-color: black; border-width: 1px; border-style: solid; ">
                                    </div>
                                </div>

                                <div class="w-auto ms-8 px-0 mt-2" >
                                    <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS" style="width: 200px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ contact.fullname }}
                                        <!-- <span>
                                                <img src="@/assets/img/check-circle.png" alt="" width="15px"> 
                                            </span>  -->

                                    </span>
                                    <span style="width: 200px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="hp-badge-text fw-normal  hp-text-color-dark-30 mt-4" >@{{ contact.username }}</span>

                                </div>

                                                    
                            </div>

                        </div>

                    </div>

                    
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import MessageRBody from '@/components/MessageRBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, Timestamp, increment, limit, startAfter, setDoc, onSnapshot } from "firebase/firestore"; 
    import {getAuth, onAuthStateChanged, signOut} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody,
            InfiniteLoading,
            MessageRBody,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",
                blobUrl: "",
                userName:"",
                
                currentPeerUser: null,
                convoList: [],
                contactList: [],
                contactListId:[],

                unsubscribe: null,

                upCount: 0,
               
            }
        },

        beforeUnmount(){
            if(this.unsubscribe != null){
                this.unsubscribe();
            }

        },

        mounted(){

            //document.body.style.overflowY = "hidden";
            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Messages';

            document.getElementById("messageN").classList.add("active");
            
            document.getElementById("messageN2").classList.add("active");

            //this.getUserList();
            this.getUserListChange();
            this.getContacts(); 
            this.updateCount();
            //this.$refs.chatBox.classList.add("mm-none");
            document.getElementById("chatBox").classList.add("mm-none");
            
            if(this.detectMob()){
                document.getElementById("addBtnMobile").style.display = "block";
            }

            

        },

    

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            detectMob() {
                return ( ( window.innerWidth <= 600 ) );
            },

            async updateCount(){

                const auth = getAuth();
                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {
                    msgList: []
                });

            },

            showChatBox(){

                if(this.detectMob()){

                    
                    //this.$refs.userListBox.classList.add("mm-none");
                    //this.$refs.userListBox.style.visibility = "hidden"
                    document.getElementById("userListBox").style.display = "none";

                    //this.$refs.chatBox.classList.remove("mm-none");
                    document.getElementById("chatBox").classList.remove("mm-none");
                    document.getElementById("headerBox").style.display = "none";
                    document.getElementById("addBtnMobile").style.display = "none";
                    
                }
            

            },

            getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            },

            profileClick(userId){

                const auth = getAuth();

                if(auth.currentUser.uid == userId){
                    this.$router.push({name: 'profile'});
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({name: 'other-profile'});
                return;

                
                

            },

            searchOpen(){

                document.getElementById("userSearch").classList.remove("d-none");
                document.getElementById("searchButtonC").classList.remove("d-none");
                document.getElementById("convoTitle").classList.add("d-none");
                document.getElementById("searchButton").classList.add("d-none");
                document.getElementById("addButton").classList.add("d-none");

            },

            searchClose(){

                document.getElementById("userSearch").classList.add("d-none");
                document.getElementById("searchButtonC").classList.add("d-none");
                document.getElementById("convoTitle").classList.remove("d-none");
                document.getElementById("searchButton").classList.remove("d-none");
                document.getElementById("addButton").classList.remove("d-none");

            },

            searchOpen2(){

                document.getElementById("chatSearch").classList.remove("d-none");
                document.getElementById("searchButtonC2").classList.remove("d-none");
                document.getElementById("uInfo").classList.add("d-none");
                document.getElementById("searchButton2").classList.add("d-none");

            },

            searchClose2(){

                document.getElementById("chatSearch").classList.add("d-none");
                document.getElementById("searchButtonC2").classList.add("d-none");
                document.getElementById("uInfo").classList.remove("d-none");
                document.getElementById("searchButton2").classList.remove("d-none");

            },

            async startChat(convo, index){

                // if(this.currentPeerUser != null && convo != null){
                //     if(this.currentPeerUser.userId == convo.userId){
                //         return;
                //     }
                // }
                
                this.currentPeerUser = convo;

                const auth = getAuth();

                $(".userCol").removeClass("bg-primary-4 hp-bg-dark-primary-2");
                $("#"+this.currentPeerUser.userId).addClass("bg-primary-4 hp-bg-dark-primary-2");
                

                this.showChatBox();
                
                if(document.getElementById("mainChatBox")!=null){
                    document.getElementById("mainChatBox").scrollIntoView({ behavior: 'smooth', block: 'end' });
                }

                

                //CREATE CONVO
                const docRef1 = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
                const docSnap1 = await getDoc(docRef1);
                if (!docSnap1.exists()){
                    await setDoc(doc(db, "UserConvo", auth.currentUser.uid , "UserList", this.currentPeerUser.userId ),{
                        userId: this.currentPeerUser.userId,
                        fullname: this.currentPeerUser.fullname,
                        username: this.currentPeerUser.username,
                        profilePic: this.currentPeerUser.profilePic,
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestampSecs: Timestamp.now().seconds,
                        lastTimestamp: serverTimestamp(),
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });
                }

                const docRef2 = doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid );
                const docSnap2 = await getDoc(docRef2);
                if (!docSnap2.exists()){
                    await setDoc(doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid ),{
                        userId: auth.currentUser.uid,
                        fullname: sessionStorage.getItem("fullName"),
                        username: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestamp: serverTimestamp(),
                        lastTimestampSecs: Timestamp.now().seconds,
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });
                }

                try{

                    const convoRef = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
                    await updateDoc(convoRef, {
                        
                        unreadCount: 0,
                        
                    });

                }
                catch(err){
                    console.log(err);
                }
                
            },

            timeFormat(date){

                let newFormat;

                TimeAgo.addDefaultLocale(en);
                const timeAgo = new TimeAgo('en-US');
                newFormat =  timeAgo.format(Number(date));

                return newFormat;

            },

            async test(){

                const auth = getAuth();

                

                try{

                    await setDoc(doc(db, "UserConvo", sessionStorage.getItem("otherId") , "UserList",  auth.currentUser.uid),{
                        userId: auth.currentUser.uid,
                        fullName: sessionStorage.getItem("fullName"),
                        userName: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        lastMsg: "",
                        lastMsgType: "",
                        lastTimestamp: serverTimestamp(),
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                        userType: sessionStorage.getItem("userType"),
                    }, {merge: true});

                }
                catch(err) {
                    console.log(err);
                }

            },

            async getContacts(){

                this.loadingText = "Loading messages...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserContact", auth.currentUser.uid, "Contact"));

                if(querySnapshot.docs.length > 0){

                    querySnapshot.forEach((doc) => {

                        this.contactList.push({
                            userId: doc.data().userId,
                            profilePic: doc.data().profilePic,
                            username: doc.data().userName,
                            fullname: doc.data().fullName,
                        })
                        
                        let mIndex = this.contactList.length - 1;
                        this.updateContactList(doc.data().userId, mIndex);

                    })

                    

                }

                
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async selectUser(contact){

                // if(this.currentPeerUser != null && contact != null){
                //     if(this.currentPeerUser.userId == contact.userId){
                //         return;
                //     }
                // }

                this.currentPeerUser = contact;
                $(".userCol").removeClass("bg-primary-4 hp-bg-dark-primary-2");
                $("#"+this.currentPeerUser.userId).addClass("bg-primary-4 hp-bg-dark-primary-2");
                
                // for(let i=0; i<this.contactList.length; i++){
                //     if(contact.userId == this.convoList[i].userId){
                //         $(".userCol").removeClass("bg-primary-4 hp-bg-dark-primary-2");
                //         $("#"+contact.userId).addClass("bg-primary-4 hp-bg-dark-primary-2");
                //         return;
                //     }
                // }

                this.showChatBox();

                if(document.getElementById("mainChatBox")!=null){
                    document.getElementById("mainChatBox").scrollIntoView({ behavior: 'smooth', block: 'end' });
                }

                //CREATE CONVO
                const auth = getAuth();

                const docRef1 = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
                const docSnap1 = await getDoc(docRef1);
                if (!docSnap1.exists()){
                    await setDoc(doc(db, "UserConvo", auth.currentUser.uid , "UserList", this.currentPeerUser.userId ),{
                        userId: this.currentPeerUser.userId,
                        fullname: this.currentPeerUser.fullname,
                        username: this.currentPeerUser.username,
                        profilePic: this.currentPeerUser.profilePic,
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestampSecs: Timestamp.now().seconds,
                        lastTimestamp: serverTimestamp(),
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });
                }

                const docRef2 = doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid );
                const docSnap2 = await getDoc(docRef2);
                if (!docSnap2.exists()){
                    await setDoc(doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid ),{
                        userId: auth.currentUser.uid,
                        fullname: sessionStorage.getItem("fullName"),
                        username: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestamp: serverTimestamp(),
                        lastTimestampSecs: Timestamp.now().seconds,
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });
                }

                try{

                    const convoRef = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
                    await updateDoc(convoRef, {
                        
                        unreadCount: 0,
                        
                    });

                }
                catch(err){
                    console.log(err);
                }

                
            },

            async getUserList(){

                //start loading...
                //this.loadingText= "Getting Messages...";
                //this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const querySnapshot = await getDocs(collection(db, "UserConvo", auth.currentUser.uid, "UserList"), where("blocked", "==", "false"));

                const docRef = doc(db, "UserConvo", auth.currentUser.uid, "UserList", );

                if(querySnapshot.docs.length < 1){

                    //CREATE CONVO
                    await setDoc(doc(db, "UserConvo", auth.currentUser.uid , "UserList", this.currentPeerUser.userId ),{
                        userId: this.currentPeerUser.userId,
                        fullname: this.currentPeerUser.fullname,
                        username: this.currentPeerUser.username,
                        profilePic: this.currentPeerUser.profilePic,
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestampSecs: Timestamp.now().seconds,
                        lastTimestamp: serverTimestamp(),
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });

                    await setDoc(doc(db, "UserConvo", this.currentPeerUser.userId , "UserList", auth.currentUser.uid ),{
                        userId: auth.currentUser.uid,
                        fullname: sessionStorage.getItem("fullName"),
                        username: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        lastMsg: "Say hello...",
                        lastMsgType: "text",
                        lastTimestamp: serverTimestamp(),
                        lastTimestampSecs: Timestamp.now().seconds,
                        unreadCount: 0,
                        blocked: "false",
                        tipAmount: 0,
                    });

                }

                // querySnapshot.forEach((doc) => {
                    
                //     let a1 = Number(doc.data().lastTimestamp.seconds) * 1000;

                //         this.convoList.push({
                //             userId: doc.data().userId,
                //             fullName: doc.data().fullName,
                //             userName: doc.data().userName,
                //             profilePic: doc.data().profilePic,
                //             lastMsg: doc.data().lastMsg,
                //             lastMsgType: doc.data().lastMsgType,
                //             lastTimestamp: doc.data().lastTimestamp,
                //             lastTimestampD: this.timeFormat(a1),
                //             unreadCount: doc.data().unreadCount,
                //             blocked: doc.data().blocked,
                //             tipAmount: doc.data().tipAmount,
                //         });

                // });

                this.getUserListChange();

            },

            async getUserListChange(){

                const auth = getAuth();

                const q = query(collection(db, "UserConvo", auth.currentUser.uid, "UserList"), where("blocked", "==", "false"), orderBy("lastTimestamp", "desc"));
                this.unsubscribe = onSnapshot(q, (snapshot) => {

                    this.convoList=[];

                    snapshot.forEach((doc) => {
                        let a1 = Number(doc.data().lastTimestampSecs) * 1000;
                        this.convoList.push({
                                userId: doc.data().userId,
                                fullname: doc.data().fullname,
                                username: doc.data().username,
                                profilePic: doc.data().profilePic,
                                lastMsg: doc.data().lastMsg,
                                lastMsgType: doc.data().lastMsgType,
                                lastTimestamp: doc.data().lastTimestamp,
                                lastTimestampD: this.timeFormat(a1),
                                unreadCount: doc.data().unreadCount,
                                blocked: doc.data().blocked,
                                tipAmount: doc.data().tipAmount,
                            })

                            let mIndex = this.convoList.length - 1;
                            this.updateConvoList(doc.data().userId, mIndex);
                            
                    });

                    if(this.currentPeerUser != null){
                        $(".userCol").removeClass("bg-primary-4 hp-bg-dark-primary-2");
                        $("#"+this.currentPeerUser.userId).addClass("bg-primary-4 hp-bg-dark-primary-2");
                    }

                    if(document.getElementById("mainChatBox")!=null){
                        document.getElementById("mainChatBox").scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }

                    
                });

            },

            async getUserListChange2(){

                const auth = getAuth();

                const q = query(collection(db, "UserConvo", auth.currentUser.uid, "UserList"), where("blocked", "==", "false"), orderBy("lastTimestamp", "desc"));
                this.unsubscribe = onSnapshot(q, (snapshot) => {

                    

                    snapshot.docChanges().forEach((change) => {
                        let a1 = Number(change.doc.data().lastTimestampSecs) * 1000;
                        
                        if (change.type === "added") {
                            
                            this.convoList.unshift({
                                userId: change.doc.data().userId,
                                fullname: change.doc.data().fullname,
                                username: change.doc.data().username,
                                profilePic: change.doc.data().profilePic,
                                lastMsg: change.doc.data().lastMsg,
                                lastMsgType: change.doc.data().lastMsgType,
                                lastTimestamp: change.doc.data().lastTimestamp,
                                lastTimestampD: this.timeFormat(a1),
                                unreadCount: change.doc.data().unreadCount,
                                blocked: change.doc.data().blocked,
                                tipAmount: change.doc.data().tipAmount,
                            })
                        }
                        if (change.type === "modified") {

                            for(let i=0 ; i < this.convoList.length; i++){
                                if(change.doc.data().userId == this.convoList[i].userId){
                                    this.convoList.splice(i, 1);
                                    this.convoList.unshift({
                                        userId: change.doc.data().userId,
                                        fullname: change.doc.data().fullname,
                                        username: change.doc.data().username,
                                        profilePic: change.doc.data().profilePic,
                                        lastMsg: change.doc.data().lastMsg,
                                        lastMsgType: change.doc.data().lastMsgType,
                                        lastTimestamp: change.doc.data().lastTimestamp,
                                        lastTimestampD: this.timeFormat(a1),
                                        unreadCount: change.doc.data().unreadCount,
                                        blocked: change.doc.data().blocked,
                                        tipAmount: change.doc.data().tipAmount,
                                    })

                                    break;
                                }
                            }

                            console.log("Modified city: ", change.doc.data());
                        }
                        if (change.type === "removed") {
                            
                            for(let i=0 ; i < this.convoList.length; i++){
                                if(change.doc.data().userId == this.convoList[i].userId){
                                    this.convoList.splice(i, 1);
                                    break;
                                }
                            }

                        }
                    });
                });

            },

            async updateContactList( userId, i){

                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                if(this.contactList[i].userId == userId){
                    this.contactList[i].profilePic = userSnap.data().profilePic;
                    this.contactList[i].fullname = userSnap.data().name;
                    this.contactList[i].username = userSnap.data().displayId;
                }
            },

            async updateConvoList( userId, i){

                this.upCount++;

                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                if(this.convoList[i].userId == userId){
                    this.convoList[i].profilePic = userSnap.data().profilePic;
                    this.convoList[i].fullname = userSnap.data().name;
                    this.convoList[i].username = userSnap.data().displayId;
                }

            }

        },
        
    }
</script>